import { makeBinding } from './baseBinding'
import { getFeatureFlag } from '../hooks/useFeatureFlag'

const selector = '[data-react-bind="root"]'
export const autoBindBindMainApp = makeBinding(() => [
  getFeatureFlag('v2'),
  document.querySelectorAll(selector),
  'root',
])
